import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './Nav.module.scss';
import Image from '../../Image';
import logo from '../../../assets/logo.jpg';
import cart from '../../../assets/nav/cart.png';
import menu from '../../../assets/nav/menu.png';
import { routes } from '../../../routes';
import useBreakpoints from '../../../hooks/use-breakpoints';
import RailsMobileNav from './RailsMobileNav';

export default function RailsCustomerNav() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const breakpoint = useBreakpoints();

  const getCurrentDomain = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('shoob.cloud')) {
      return 'https://www.shoob.cloud';
    } else {
      return 'https://www.shoobphoto.com';
    }
  }

  useEffect(() => {
    if (!isOpen) return;

    setIsLoginOpen(false);
  }, [isOpen]);

  useEffect(() => {
    if (!isLoginOpen) return;

    setIsOpen(false);
  }, [isLoginOpen]);

  if (['lg', 'md', 'sm'].includes(breakpoint)) return <RailsMobileNav />;

  return (
    <nav
      className={cn({
        [styles.navContainer]: true,
        noPrint: true,
      })}
    >
      <div className={cn(styles.cartLink, styles.dropdown)} style={{ marginLeft: '1em' }}>
        <button
          className={styles.button}
          style={{ padding: '.5em' }}
          onClick={() => setIsLoginOpen(!isLoginOpen)}
          type="button"
        >
          <Image alt="Menu" src={menu} />
        </button>
        <ul
          className={cn({
            [styles.dropdownMenu]: true,
            [styles.hidden]: !isLoginOpen,
          })}
        >
          <li>
            <a href="/users/sign_in">
              School Login
            </a>
          </li>
          <li>
            <a href="/users/sign_in">
              Shoob Employee Login
            </a>
          </li>
        </ul>
      </div>
      <a href="/">
        <Image src={logo} classes={styles.logo} />
      </a>
      <ul className={styles.nav}>
        <li className={styles.dropdown}>
          <button
            className={styles.button}
            onClick={() => setIsOpen(!isOpen)}
            type="button"
          >
            Order
          </button>
          <ul
            className={cn({
              [styles.dropdownMenu]: true,
              [styles.hidden]: !isOpen,
            })}
          >
            <li>
              <a href={`/c${routes.studentIdEntry()}`}>
                School Pictures
              </a>
            </li>
            <li>
              <a href={`/c${routes.studentIdEntry({ order: 'senior' })}`}>
                Senior Portraits
              </a>
            </li>
            <li>
              <a href={`/c${routes.studentIdEntry({ order: 'yearbook_order' })}`}>
                Yearbooks
              </a>
            </li>
            <li>
              <a href={`/c${routes.studentIdEntry({ order: 'panorama' })}`}>
                Groups and Panorama
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a href="/seniors">
            Seniors
          </a>
        </li>
        <li>
          <a href={`/c${routes.scheduleAppointment()}`}>
            Make Appointment
          </a>
        </li>
        <li>
          <a href={`/c${routes.downloadImageForm()}`}>
            Download Digital Files
          </a>
        </li>
        <li>
          <a href={getCurrentDomain() === 'https://www.shoob.cloud' ? 'https://www.shoobphotosouth.com/contact1' : '/contacts/new'}>
            Contact Us
          </a>
        </li>
        <li>
          <a href="/school_resources">
            Resources for Schools
          </a>
        </li>
        <li>
          <a href={`/c${routes.registration()}`}>
            Register
          </a>
        </li>
      </ul>
      <a className={styles.cartLink} href={`/c${routes.cart()}`}>
        <Image src={cart} />
      </a>
    </nav>
  );
}
